function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_864",
  "data-name": "Group 864",
  transform: "translate(-1410.5 -1177.605)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_767",
  "data-name": "Group 767",
  transform: "translate(1411 1178.105)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_637",
  "data-name": "Path 637",
  d: "M8.776-27.5v3.862",
  transform: "translate(-5.588 44.969)",
  fill: "none",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_638",
  "data-name": "Path 638",
  d: "M16.277-22.79v1.931",
  transform: "translate(-10.013 42.191)",
  fill: "none",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_639",
  "data-name": "Path 639",
  d: "M6.354-18.082h4.961v.412H6.354Z",
  transform: "translate(-4.158 39.413)",
  fill: "rgba(0,0,0,0)",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1,
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_640",
  "data-name": "Path 640",
  d: "M42.2-27.5v3.862",
  transform: "translate(-25.304 44.969)",
  fill: "none",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_641",
  "data-name": "Path 641",
  d: "M34.7-22.79v1.931",
  transform: "translate(-20.879 42.191)",
  fill: "none",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_642",
  "data-name": "Path 642",
  d: "M32.519-18.078H37.48v.41H32.519Z",
  transform: "translate(-19.595 39.411)",
  fill: "rgba(0,0,0,0)",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1,
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_631",
  "data-name": "Path 631",
  d: "M11-70.1a10,10,0,0,1,10,10,10,10,0,0,1-10,10,10,10,0,0,1-10-10A10,10,0,0,1,11-70.1Z",
  transform: "translate(-1 70.104)",
  fill: "rgba(0,0,0,0)",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1,
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_632",
  "data-name": "Path 632",
  d: "M14.272-64.558A7.729,7.729,0,0,1,22-56.832a7.729,7.729,0,0,1-7.726,7.726,7.729,7.729,0,0,1-7.726-7.726A7.729,7.729,0,0,1,14.272-64.558Z",
  transform: "translate(-4.272 66.832)",
  fill: "rgba(0,0,0,0)",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1,
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_643",
  "data-name": "Path 643",
  d: "M23.8-48.413A1.106,1.106,0,0,1,24.9-47.307,1.106,1.106,0,0,1,23.8-46.2a1.106,1.106,0,0,1-1.106-1.106A1.106,1.106,0,0,1,23.8-48.413Z",
  transform: "translate(-13.797 57.307)",
  fill: "rgba(0,0,0,0)",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1,
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_644",
  "data-name": "Path 644",
  d: "M7.66-45.716H9.427",
  transform: "translate(-4.929 55.716)",
  fill: "none",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_645",
  "data-name": "Path 645",
  d: "M8.725-51.769l1.661.6",
  transform: "translate(-5.557 59.287)",
  fill: "none",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_646",
  "data-name": "Path 646",
  d: "M11.793-57.094l1.355,1.134",
  transform: "translate(-7.367 62.429)",
  fill: "none",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_647",
  "data-name": "Path 647",
  d: "M16.494-61.052l.887,1.529",
  transform: "translate(-10.141 64.764)",
  fill: "none",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_648",
  "data-name": "Path 648",
  d: "M22.264-63.167l.311,1.74",
  transform: "translate(-13.545 66.012)",
  fill: "none",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_649",
  "data-name": "Path 649",
  d: "M27.976-63.185l-.3,1.741",
  transform: "translate(-16.737 66.022)",
  fill: "none",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_636",
  "data-name": "Path 636",
  d: "M32.929-61.1l-.878,1.534",
  transform: "translate(-19.319 64.795)",
  fill: "none",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_635",
  "data-name": "Path 635",
  d: "M36.975-57.174l-1.349,1.142",
  transform: "translate(-21.428 62.476)",
  fill: "none",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_633",
  "data-name": "Path 633",
  d: "M39.63-51.867l-1.658.613",
  transform: "translate(-22.812 59.345)",
  fill: "none",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_634",
  "data-name": "Path 634",
  d: "M40.573-45.822l-1.767.011",
  transform: "translate(-23.304 55.778)",
  fill: "none",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_650",
  "data-name": "Path 650",
  d: "M29.5-53,27.291-50.8",
  transform: "translate(-16.511 60.015)",
  fill: "none",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_651",
  "data-name": "Path 651",
  d: "M20.309-43.814,18.1-41.607",
  transform: "translate(-11.089 54.594)",
  fill: "none",
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_652",
  "data-name": "Path 652",
  d: "M21.636-35.883H22.66v-1.024H21.636Z",
  transform: "translate(-13.175 50.519)",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_653",
  "data-name": "Path 653",
  d: "M26.647-35.883h1.024v-1.024H26.647Z",
  transform: "translate(-16.131 50.519)",
  fillRule: "evenodd"
})));

var SvgAnalyzers = function SvgAnalyzers(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22.743,
    viewBox: "0 0 21 22.743",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAnalyzers, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/analyzers.ace7e29e.svg";
export { ForwardRef as ReactComponent };